// Tipos de lançamento: receita | despesa | transf_entrada | transf_saida.
// As pernas de transferência movem saldo dos bancos, mas ficam fora dos
// totais de receita/despesa e do planejamento.

export const isEntrada = (tipo: string): boolean =>
  tipo === 'receita' || tipo === 'transf_entrada' || tipo === 'repasse_entrada';

export const isTransferencia = (tipo: string): boolean =>
  tipo === 'transf_entrada' || tipo === 'transf_saida';

const LABELS: Record<string, string> = {
  receita: 'Receita',
  despesa: 'Despesa',
  transf_entrada: 'Transf. recebida',
  transf_saida: 'Transf. enviada',
  pagamento_fatura: 'Pgto. de fatura',
  repasse_entrada: 'Repasse recebido',
  repasse_saida: 'Repasse enviado',
};

export const labelTipo = (tipo: string): string => LABELS[tipo] || tipo;

const isRepasse = (tipo: string): boolean =>
  tipo === 'repasse_entrada' || tipo === 'repasse_saida';

// Esquema de cores do Chakra para tags
export const corTipo = (tipo: string): string =>
  isRepasse(tipo) ? 'gray' : tipo === 'pagamento_fatura' ? 'purple' : isTransferencia(tipo) ? 'blue' : tipo === 'receita' ? 'teal' : 'red';

// Cor de texto para valores
export const corTextoTipo = (tipo: string): string =>
  isRepasse(tipo) ? 'gray.500' : tipo === 'pagamento_fatura' ? 'purple.500' : isTransferencia(tipo) ? 'blue.500' : tipo === 'receita' ? 'teal.600' : 'red.500';

// Descrição sem o ruído do banco, para caber numa linha no celular: tira a
// origem ([pluggy]/[bot]), o "COMPRA CARTAO DEB MC 21/07" e espaços repetidos
export function descricaoCurta(lanc: { descricao?: string | null; categoria?: { nome?: string } | null }): string {
  const d = String(lanc.descricao || '')
    .replace(/^\[(bot|pluggy)\]\s*/i, '')
    .replace(/^COMPRA CARTAO DEB\s+\w*\s+\d{2}\/\d{2}\s+/i, '')
    .replace(/\s+/g, ' ')
    .trim();
  return d || lanc.categoria?.nome || 'Sem descrição';
}
